import {UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../constants.ts";

export type Category = {
    l1: string
    l2: string
    l3: string
    l4: string
    l5: string
    l6: string
    l7: string
    l8: string
}
export type ApiCategory = Category & {
    id: number
}
export type Labels = string[]
export type PartialCategory = Partial<Category>
export type PartialValidCategory = PartialCategory & {l1: string}

export function categoryToLabels(c: Category, taxonomySize: number = 8, filterTrailingUncat: boolean, trimEqualLeaves: boolean): Labels {
    let result = new Array(taxonomySize);
    for (let i = 0; i < taxonomySize; i++) {
        result[i] = c[`l${i + 1}`] || '';
    }
    if (filterTrailingUncat) {
        let lastNonUncatIndex = -1;
        for (let i = 0; i < result.length; i++) {
            if (result[i] && result[i] !== UNCATEGORIZED_VALUE) {
                lastNonUncatIndex = i;
            }
        }
        result = result.slice(0, lastNonUncatIndex + 1);
    }
    if (trimEqualLeaves) {
        // Remove leaves that are exactly equal from the end of the labels[]
        let i = result.length - 2;
        while (i >= 0 && result[i] === result[i + 1]) {
            i--;
        }
        result = result.slice(0, i + 2);
    }
    return result;
}

export function categoryToLabelsWithPrefix(c: Record<string, string>, fieldPrefix = 'l', fieldPostfix = '', taxonomySize: number = 8, array_filed = false): Labels {
    const result = new Array(taxonomySize);
    for (let i = 0; i < taxonomySize; i++) {
        if (array_filed) {
            const arr = c[`${fieldPrefix}${i + 1}${fieldPostfix}`];
            if (!Array.isArray(arr)) {
                console.warn('Expected array field but got non-array:', arr);
                break
            }
            result[i] = arr.at(0);
        } else {
            result[i] = c[`${fieldPrefix}${i + 1}${fieldPostfix}`];
        }
        if (!result[i]) result[i] = '';
    }
    return result;
}

export function labelsToCategory(labels: Labels): Category {
    const result = {};
    for (let i = 0; i < Math.max(labels.length, 8); i++) {
        if (i < labels.length) {
            result[`l${i + 1}`] = labels[i] || '';
        } else {
            result[`l${i + 1}`] = '';
        }
    }
    return result as Category;
}

export function isValidCategory(c: Partial<ApiCategory> | null | undefined | false): c is Category {
    if (!c) return false;
    // noinspection RedundantIfStatementJS
    if (c.l1) return true;
    return false;
}

export function categoryExportString(c?: Category): string {
    if (c === undefined) return '';

    // TODO [CAT-3205]: The taxonomy data model is not complete enough to deal with the trimming of equal leaves
    const cats = categoryToLabels(c, 8, false, false);

    if (cats.every(c => !c)) return UNCATEGORIZED_LABEL;
    return cats.filter(c => c !== UNCATEGORIZED_VALUE).join(' > ');
}